// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pq-create-page {
  background: #f9fafb;
  min-height: 100vh;
}

.pq-create-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  /* margin: 18px 18px 0; */
  padding: 22px 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.pq-create-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  line-height: 1.35;
}

.pq-create-subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  color: #64748b;
}

.pq-create-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 16px;
  padding: 16px 18px 24px;
  align-items: start;
}

.pq-main-panel,
.pq-side-panel {
  min-width: 0;
}

.pq-create-card,
.pq-workflow-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: none;
}

.pq-create-card-body {
  padding: 24px;
}

.pq-workflow-card-head {
  padding: 16px 18px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.pq-workflow-card-body {
  padding: 18px;
}

.pq-top-cancel-btn,
.pq-footer-cancel-btn {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #1e293b;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-footer-primary-btn {
  height: 40px;
  padding: 0 20px;
  border: 0;
  background: #2563eb;
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-footer-primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pq-bottom-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #e5e7eb;
}

.pq-add-agent-form-wrap {
  /* border: 1px solid #e5e7eb; */
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.pq-add-agent-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 18px 14px;
  border-bottom: 1px solid #e5e7eb;
}

.pq-add-agent-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.pq-add-agent-subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  color: #64748b;
}

.pq-add-agent-close {
  width: 40px;
  height: 40px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 10px;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-add-agent-section {
  border-top: 1px solid #e5e7eb;
}

.pq-add-agent-section:first-of-type {
  border-top: 0;
}

.pq-add-agent-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  font-size: 18px;
  font-weight: 700;
  color: #334155;
  background: #fff;
}

.pq-add-agent-section-head i.orange { color: #f97316; }
.pq-add-agent-section-head i.green { color: #22c55e; }
.pq-add-agent-section-head i.purple { color: #a855f7; }
.pq-add-agent-section-head i.pink { color: #ec4899; }

.pq-add-agent-grid-1,
.pq-add-agent-grid-2,
.pq-add-agent-grid-3 {
  display: grid;
  gap: 18px;
  padding: 0 18px 18px;
}

.pq-add-agent-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.pq-add-agent-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.pq-form-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.pq-text-input,
.pq-textarea,
.pq-select-input {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #111827;
  font-size: 14px;
}

.pq-text-input,
.pq-select-input {
  height: 42px;
  padding: 0 14px;
}

.pq-textarea {
  min-height: 130px;
  padding: 14px 16px;
  resize: vertical;
  line-height: 1.6;
}

.pq-text-input::placeholder,
.pq-textarea::placeholder {
  color: #94a3b8;
}

.pq-text-input:focus,
.pq-textarea:focus,
.pq-select-input:focus {
  outline: none;
  border-color: #94a3b8;
  box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.15);
}

.pq-upload-zone {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  background: #f8fafc;
  text-align: center;
  padding: 40px 20px;
}

.pq-upload-zone.drag-over {
  border-color: #60a5fa;
  background: #eff6ff;
}

.pq-upload-icon {
  font-size: 44px;
  color: #9ca3af;
  margin-bottom: 12px;
}

.pq-upload-title {
  font-size: 15px;
  color: #334155;
  margin-bottom: 6px;
}

.pq-upload-or {
  font-size: 14px;
  color: #94a3b8;
  margin-bottom: 14px;
}

.pq-upload-hint {
  margin-top: 12px;
  font-size: 12px;
  color: #94a3b8;
}

.pq-workflow-list-wrap {
  position: relative;
}

.pq-workflow-row {
  position: relative;
  display: flex;
  gap: 12px;
  padding-bottom: 22px;
}

.pq-workflow-left {
  position: relative;
  width: 32px;
  flex-shrink: 0;
}

.pq-workflow-line {
  position: absolute;
  left: 15px;
  top: 34px;
  bottom: -10px;
  width: 2px;
  background: #d1d5db;
}

.pq-workflow-icon {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  position: relative;
  z-index: 1;
}

.pq-workflow-icon.blue { background: #dbeafe; color: #2563eb; }
.pq-workflow-icon.purple { background: #f3e8ff; color: #9333ea; }
.pq-workflow-icon.green { background: #dcfce7; color: #16a34a; }
.pq-workflow-icon.orange { background: #ffedd5; color: #ea580c; }
.pq-workflow-icon.mint { background: #dcfce7; color: #059669; }

.pq-workflow-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}

.pq-workflow-detail,
.pq-workflow-assigned {
  font-size: 14px;
  line-height: 1.5;
  color: #64748b;
}

@media (max-width: 1200px) {
  .pq-create-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .pq-create-header {
    flex-direction: column;
    align-items: stretch;
  }

  .pq-add-agent-grid-2,
  .pq-add-agent-grid-3 {
    grid-template-columns: 1fr;
  }

  .pq-bottom-actions {
    flex-direction: column;
  }

  .pq-top-cancel-btn,
  .pq-footer-cancel-btn,
  .pq-footer-primary-btn {
    width: 100%;
  }
}


/* Replace your top-level view layout CSS with this: */

.project-quote-page.pq-page-shell {
  /* background: #f8fafc; */
  min-height: 100vh;
  padding: 20px;
}

.pq-view-head.pq-ref-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 22px 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.pq-layout-two-col {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 18px;
  align-items: start;
}

.pq-main-col {
  min-width: 0;
}

.pq-sticky-side {
  position: sticky;
  top: 20px;
}


/* Make all cards look like the reference card style */

.pq-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: none;
  overflow: hidden;
}

.pq-section-card {
  margin-bottom: 18px;
}

.pq-card-head {
  padding: 14px 18px;
  border-bottom: 1px solid #e5e7eb;
}

.pq-card-body {
  padding: 20px 22px;
}

/* .pq-ref-card-head-blue {
  background: linear-gradient(to right, #eff6ff, #ffffff);
  border-bottom-color: #dbeafe;
} */

.pq-ref-card-head-indigo {
  background: linear-gradient(to right, #eef2ff, #ffffff);
  border-bottom-color: #e0e7ff;
}
/* 
.pq-ref-head-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 18px !important;
  font-weight: 700;
  color: #1e3a8a;
} */



/* Adjust the page header to match the reference */

.pq-view-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pq-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
}

.pq-ref-divider {
  width: 1px;
  height: 20px;
  background: #d1d5db;
}

.pq-view-title {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #111827;
}

.pq-status-pill {
  display: inline-flex;
  align-items: center;
  /* height: 30px; */
  padding: 0 12px;
  border-radius: 999px;
  background: #e0e7ff;
  color: #3730a3;
  font-size: 12px;
  font-weight: 700;
}



/* Make the agent info section look cleaner like the reference */

.pq-agent-grid-top {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 18px;
}

.pq-agent-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  /* border: 1px solid #e5e7eb; */
  border-radius: 12px;
  /* background: #f8fafc; */
}

.pq-agent-item-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.pq-agent-item-icon.user { background: #eff6ff; color: #2563eb; }
.pq-agent-item-icon.email { background: #eef2ff; color: #4f46e5; }
.pq-agent-item-icon.phone { background: #ecfeff; color: #0891b2; }
.pq-agent-item-icon.brokerage { background: #f5f3ff; color: #7c3aed; }

/* .pq-k {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 4px;
} */
/* 
.pq-v {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  line-height: 1.5;
} */

.pq-block-value {
  margin-top: 4px;
}

/* .pq-additional-btn {
  margin-top: 16px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 10px;
  height: 38px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 600;
} */

.pq-agent-grid-bottom,
.pq-agent-address-grid,
.pq-meta-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.pq-split-line {
  border-top: 1px solid #e5e7eb;
  margin: 18px 0;
}

/* .pq-address-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
} */

/* Make conversation and shared files section match reference
 * DUPLICATE class names also defined in projectandquote-view.css (project view).
 * Kept commented to avoid fighting the view page styles.
 *
.pq-conversation-card-body { padding: 0; }
.pq-tabs-with-right { display: flex; align-items: center; gap: 0; border-bottom: 1px solid #e5e7eb; padding: 0 18px; }
.pq-tab { height: 52px; padding: 0 16px; border: 0; background: transparent; color: #64748b; font-size: 14px; font-weight: 600; border-bottom: 2px solid transparent; }
.pq-tab.active { color: #2563eb; border-bottom-color: #2563eb; }
.pq-mute-btn { margin-left: auto; border: 1px solid #cbd5e1; background: #fff; color: #334155; border-radius: 10px; height: 36px; padding: 0 12px; font-size: 13px; font-weight: 600; }
.pq-convo-list, .pq-shared-files { padding: 18px; }
.pq-convo-item { border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; background: #fff; }
.pq-convo-item + .pq-convo-item { margin-top: 14px; }
... (truncated in comment — see git history if needed)
*/

/* Make shared files section match reference better */


.pq-proof-group {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.pq-proof-group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 13px;
  font-weight: 700;
}

.pq-proof-group-head.plain {
  background: #f8fafc;
  color: #475569;
}

.pq-proof-chip {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #c7d2fe;
  color: #3730a3;
  font-size: 12px;
  font-weight: 700;
}

.pq-file-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  border-top: 1px solid #eef2f7;
}

.pq-file-type {
  min-width: 48px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  background: #f1f5f9;
  color: #475569;
}

.pq-file-meta {
  min-width: 0;
  flex: 1 1;
}

.pq-file-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.pq-file-sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.pq-file-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}


/* . Match the right sidebar workflow + quick action card to reference */

.pq-sidebar-body {
  padding: 18px;
}

.pq-workflow-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pq-workflow-item {
  position: relative;
  display: flex;
  gap: 12px;
  padding-bottom: 20px;
}

.pq-workflow-item:not(:last-child)::after {
  content: "";
  position: absolute;
  left: 14px;
  top: 34px;
  bottom: 0;
  width: 2px;
  background: #e5e7eb;
}

.pq-workflow-dot {
  position: relative;
  z-index: 1;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pq-workflow-dot.done {
  background: #dcfce7;
  color: #16a34a;
}

.pq-workflow-dot.progress {
  background: #ede9fe;
  color: #7c3aed;
}

.pq-workflow-dot.pending {
  background: #f3f4f6;
  color: #6b7280;
}

.pq-wf-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.pq-wf-sub {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.pq-wf-sub.done { color: #16a34a; }
.pq-wf-sub.progress { color: #7c3aed; }


.pq-side-section {
  margin-top: 18px;
}

.pq-side-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #166534;
}

.pq-side-box {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  padding: 14px;
  margin-bottom: 14px;
}

.pq-side-box-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 800;
  color: #334155;
  letter-spacing: 0.04em;
}

.pq-radio-row,
.pq-order-option {
  display: block;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
  margin-bottom: 10px;
}

.pq-radio-row.selected,
.pq-order-option:has(input:checked) {
  border-color: #93c5fd;
  background: #f8fbff;
}

/* view file css code  */


.pq-page-shell {
  padding: 20px 22px 28px;
  background: #f9fafb;
}

.pq-main-col,
.pq-section-card {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.pq-section-card {
  margin-bottom: 14px;
}

.pq-ref-head {
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

.pq-ref-title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.25;
  color: #111827;
}


.pq-page-subtitle strong {
  color: #111827;
  font-weight: 700;
}

.pq-back-link {
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
}

.pq-ref-divider {
  width: 1px;
  height: 28px;
  background: #d1d5db;
}

.pq-status-pill {
  background: #cffafe;
  color: #0e7490;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 999px;
}

.pq-ref-actions {
  height: 44px;
  min-width: 152px;
  border-radius: 12px;
  font-size: 14px;
  padding: 0 16px;
}

.pq-actions-wrap {
  position: relative;
}

.pq-actions-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 170px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  z-index: 20;
  overflow: hidden;
}

.pq-actions-menu button {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 12px 14px;
  text-align: left;
  font-size: 14px;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 10px;
}

.pq-actions-menu button:hover {
  background: #f8fafc;
}

.pq-layout-two-col {
  display: grid;
  grid-template-columns: minmax(0, 2fr) 520px;
  gap: 16px;
  align-items: start;
}

.pq-card {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: none;
}

.pq-card-head {
  min-height: 44px;
  padding: 12px 16px;
}

/* .pq-ref-card-head-blue {
  background: #eef4ff;
} */

.pq-ref-card-head-indigo {
  background: #eef2ff;
}

/* .pq-ref-head-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #1d4ed8;
} */

/* .pq-ref-card-head-indigo .pq-ref-head-title {
  color: #3730a3;
} */

.pq-card-body {
  padding: 18px 16px;
}

.pq-agent-grid-top1 {
  gap: 0px 27px;
}

.pq-agent-grid-bottom {
  margin-top: 2px;
  gap: 18px 26px;
}

.pq-agent-address-grid {
  margin-top: 10px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px 26px;
}

/* .pq-k {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 5px;
} */

/* .pq-v {
  font-size: 15px;
  line-height: 1.45;
  font-weight: 600;
  color: #111827;
} */

.pq-block-value {
  margin-bottom: 16px;
}

/* .pq-additional-btn {
  margin-top: 16px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;
  background: #fff;
} */

.pq-space-top {
  margin-top: 14px;
}

/* .pq-address-heading {
  font-size: 12px;
  color: #334155;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
} */

.pq-meta-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

/* Duplicate conversation chrome (canonical: projectandquote-view.css)
.pq-conversation-card-body { padding: 0; }
.pq-tabs-with-right { margin: 0; padding: 0 16px; min-height: 42px; display: flex; align-items: center; gap: 18px; background: #eff6ff; border-bottom: 1px solid #dbeafe; }
.pq-tab { display: inline-flex; align-items: center; gap: 6px; height: 42px; font-size: 14px; font-weight: 500; }
.pq-tab.active { color: #2563eb; border-bottom: 2px solid #2563eb; }
.pq-mute-btn { margin-left: auto; font-size: 14px; display: inline-flex; align-items: center; gap: 6px; }
.pq-convo-list { margin: 12px 16px 14px; padding: 14px; max-height: 540px; overflow-y: auto; border: 1px solid #e5e7eb; border-radius: 12px; background: #f8fafc; }
.pq-convo-item { margin-bottom: 18px; }
.pq-convo-item:last-child { margin-bottom: 0; }
*/

.pq-convo-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.pq-convo-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pq-convo-user-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pq-convo-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  color: #64748b;
  flex-shrink: 0;
}

.pq-convo-avatar.agent {
  background: #e5e7eb;
  color: #64748b;
}

.pq-convo-avatar.designer {
  background: #dbeafe;
  color: #2563eb;
}

.pq-convo-role {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.pq-convo-time {
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
}

.pq-convo-bubble-wrap {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  /* padding: 16px; */
}


.pq-attachments {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pq-attachment {
  min-height: 54px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 12px;
}

.pq-attachment-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pq-attachment-fileicon {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  flex-shrink: 0;
}

.pq-attachment-content {
  min-width: 0;
}

.pq-attachment-topline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pq-attachment-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.pq-attachment-download {
  border: 0;
  background: transparent;
  color: #64748b;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pq-attachment-download:hover {
  background: #f8fafc;
}

.pq-proof-badge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #ede9fe;
  color: #4f46e5;
  font-size: 12px;
  font-weight: 600;
}

/* .pq-convo-input-wrap {
  margin: 0 16px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
} */

.pq-msg-input {
  width: 100%;
  min-height: 114px;
  border: 0;
  resize: vertical;
  padding: 16px;
  font-size: 14px;
}

.pq-msg-input:focus {
  outline: none;
  box-shadow: none;
}

.pq-attached-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 16px 14px;
}

.pq-attached-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 500;
}

.pq-msg-actions {
  min-height: 60px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pq-msg-actions--composer {
  flex-wrap: wrap;
  gap: 10px 12px;
  justify-content: flex-start;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.pq-msg-actions--composer .pq-send-btn {
  margin-left: auto;
}

.pq-msg-actions--composer .pq-send-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: auto;
}

.pq-msg-toolbar-divider {
  width: 1px;
  height: 28px;
  background: #e5e7eb;
  flex-shrink: 0;
}

.pq-design-proof-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.pq-design-proof-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
}

.pq-design-proof-toggles {
  display: inline-flex;
  gap: 8px;
}

.pq-toggle-yesno {
  min-width: 48px;
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.pq-toggle-yesno:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.pq-toggle-yesno.active {
  border-color: #3b82f6;
  background: #eff6ff;
  color: #1d4ed8;
}

.pq-msg-toolbar-meta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #64748b;
  font-size: 13px;
}

/* .pq-emoji-inline-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
} */

.pq-emoji-inline-btn:hover {
  background: #e2e8f0;
  color: #334155;
}

.pq-attached-count-text {
  white-space: nowrap;
}

.pq-attached-pill--file {
  max-width: 100%;
  gap: 8px;
}

.pq-attached-pill-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  color: #1e40af;
}

.pq-attached-pill-size {
  color: #3b82f6;
  font-weight: 500;
  font-size: 11px;
  flex-shrink: 0;
}

.pq-attached-pill-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
  padding: 0;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #1d4ed8;
  cursor: pointer;
}

.pq-attached-pill-remove:hover {
  background: rgba(59, 130, 246, 0.15);
}

.pq-convo-top-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.pq-reply-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #475569;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
}

.pq-reply-btn:hover {
  border-color: #c0cedf;
  color: #1e293b;
}

.pq-reply-inline {
  border-left: 3px solid #2563eb;
  background: #f8fafc;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pq-reply-inline strong {
  font-size: 12px;
  color: #1d4ed8;
}

.pq-reply-inline span {
  font-size: 12px;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pq-replying-bar {
  margin: 10px 14px 0;
  border-left: 3px solid #2563eb;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pq-replying-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pq-replying-meta strong {
  font-size: 12px;
  color: #1d4ed8;
}

.pq-replying-meta span {
  font-size: 12px;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pq-replying-cancel {
  border: 0;
  background: transparent;
  color: #64748b;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-replying-cancel:hover {
  background: #e2e8f0;
}

.pq-last-message-btn {
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  text-align: left;
  cursor: pointer;
  box-shadow:none;
}

.pq-last-message-text {
  font-size: 14px;
  font-weight: 400;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pq-last-message-text--unread {
  font-weight: 700;
}

.pq-last-message-btn:hover .pq-last-message-text {
  color: #1d4ed8;
  text-decoration: none;
}

.pq-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #3b82f6;
  box-shadow: 0 0 0 rgba(59, 130, 246, 0.6);
  animation: pq-live-pulse 1.4s infinite;
  flex-shrink: 0;
}

.pq-live-dot--approved {
  background: #22c55e;
  box-shadow: 0 0 0 rgba(34, 197, 94, 0.6);
  animation: pq-live-pulse-approved 1.4s infinite;
}

@keyframes pq-live-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.55);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(59, 130, 246, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

@keyframes pq-live-pulse-approved {
  0% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
  }
  70% {
    box-shadow: 0 0 0 7px rgba(34, 197, 94, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

.pq-msg-actions-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pq-btn-sm {
  height: 38px;
  padding: 0 14px;
}

.pq-send-btn {
  height: 38px;
  min-width: 92px;
  border-radius: 10px;
}

.pq-sidebar-body {
  padding: 0;
}

.pq-workflow-list {
  padding: 18px 18px 10px;
}

.pq-workflow-timeline::before {
  left: 32px;
  top: 34px;
  bottom: 28px;
}

.pq-workflow-item {
  gap: 14px;
  padding: 8px 0 18px;
}

.pq-workflow-dot {
  width: 30px;
  height: 30px;
  margin-top: 2px;
}

.pq-wf-title {
  font-size: 15px;
  font-weight: 700;
}



.pq-side-section {
  border-top: 1px solid #dcfce7;
  margin-top: 8px;
  /* padding: 14px 18px 18px; */
}

.pq-side-section-green {
  background: linear-gradient(to bottom, #f0fdf4 0, #ffffff 70px);
}

.pq-side-title {
  margin: 0 0 12px;
  color: #166534;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(to right, #f0fdf4, #f8faff);
}

.pq-side-box {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 12px;
}

.pq-side-box:last-child {
  margin-bottom: 0;
}

.pq-side-box-title {
  min-height: 42px;
  padding: 8px 14px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.04em;
}

.pq-radio-row {
  min-height: 60px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}

.pq-radio-row:last-of-type {
  border-bottom: 1px solid #f1f5f9;
}

.pq-radio-row.selected {
  background: #eff6ff;
}

.pq-radio-row input {
  margin: 0;
}

.pq-proof-option-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pq-proof-label {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.pq-proof-file-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  color: #4b5563;
}

.pq-full-btn {
  width: calc(100% - 28px);
  margin: 14px;
  height: 44px;
  border-radius: 10px;
}

.pq-btn-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.pq-required {
  color: #ef4444;
}

.pq-order-option {
  min-height: 72px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}

.pq-order-option input {
  margin: 0;
}

.pq-order-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pq-order-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  flex-shrink: 0;
}

.pq-order-row strong {
  display: block;
  font-size: 14px;
  color: #111827;
  margin-bottom: 2px;
}

.pq-order-row small {
  display: block;
  font-size: 13px;
  color: #64748b;
}

.pq-cancel-btn {
  color: #dc2626;
  border-color: #fecaca;
  background: #fff5f5;
}

.pq-cancel-btn:hover {
  background: #fef2f2;
}

.pq-sticky-side {
  position: sticky;
  top: 18px;
}

@media (max-width: 1200px) {
  .pq-layout-two-col {
    grid-template-columns: 1fr;
  }

  .pq-sticky-side {
    position: static;
  }
}

@media (max-width: 768px) {
  .pq-page-shell {
    padding: 14px;
  }

  .pq-view-head {
    flex-direction: column;
    align-items: stretch;
  }

  .pq-view-title-row {
    flex-wrap: wrap;
    gap: 10px;
  }

  .pq-ref-divider {
    display: none;
  }

  .pq-agent-grid,
  .pq-meta-row,
  .pq-agent-address-grid {
    grid-template-columns: 1fr;
  }


  .pq-convo-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .pq-msg-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .pq-send-btn,
  .pq-msg-actions-left,
  .pq-attach-label {
    width: 100%;
    justify-content: center;
  }
}


/* addandedit project and quote css code  */


.pq-create-page {
  background: #f8fafc;
  min-height: 100vh;
  padding: 0;
}

.pq-create-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 28px 28px 24px;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.pq-create-title {
  margin: 0;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 500;
  color: #111827;
}

.pq-create-subtitle {
  margin: 8px 0 0;
  font-size: 14px;
  color: #475569;
}

.pq-top-cancel-btn,
.pq-footer-cancel-btn {
  height: 40px;
  padding: 0 20px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #1e293b;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-footer-primary-btn {
  height: 44px;
  padding: 0 22px;
  border: 0;
  background: #2563eb;
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: none;
}

.pq-create-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 480px;
  gap: 22px;
  padding: 32px 28px 28px;
  align-items: start;
}

.pq-create-card,
.pq-workflow-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  overflow: hidden;
}

.pq-create-card-body {
  padding: 26px 34px 28px;
}

.pq-form-group {
  margin-bottom: 24px;
}

.pq-form-label {
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.pq-light-text {
  color: #94a3b8;
  font-weight: 500;
}

.pq-search-input-wrap {
  position: relative;
  max-width: 605px;
  margin-bottom: 14px;
}

.pq-search-input-wrap i {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #94a3b8;
}

.pq-search-input {
  width: 100%;
  height: 48px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 0 16px 0 50px;
  font-size: 14px;
  color: #111827;
  outline: none;
  background: #fff;
}

.pq-search-input::placeholder {
  color: #94a3b8;
}

.pq-add-agent-btn {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #2563eb;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

/* Agent / brokerage search: SearchBrokerageAgentTeam (users/:customerGroupId/created-or-linked-detailed) */
.pq-agent-picker-wrap {
  position: relative;
  max-width: 605px;
  margin-bottom: 14px;
  z-index: 6;
}

.pq-search-bat-project.pq-agent-picker-wrap {
  max-width: min(100%, 720px);
}

.pq-search-input-wrap--picker.pq-search-input-wrap--clearable .pq-search-input {
  padding-right: 44px;
}

.pq-agent-picker-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
}

.pq-agent-picker-clear:hover {
  background: #f1f5f9;
  color: #111827;
}

.pq-agent-picker-dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);
}

.pq-agent-picker-status {
  padding: 14px 16px;
  font-size: 14px;
  color: #64748b;
}

.pq-agent-picker-row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
  cursor: pointer;
  text-align: left;
}

.pq-agent-picker-row:last-of-type {
  border-bottom: none;
}

.pq-agent-picker-row:hover {
  background: #f8fafc;
}

.pq-agent-picker-avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-agent-picker-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pq-agent-picker-name {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

.pq-agent-picker-sub {
  font-size: 13px;
  color: #64748b;
  line-height: 1.35;
}

.pq-agent-picker-more {
  width: 100%;
  padding: 12px 14px;
  border: none;
  border-top: 1px solid #f1f5f9;
  background: #f8fafc;
  color: #2563eb;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-agent-picker-more:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* .pq-add-agent-form-wrap {
  border-top: 1px solid #e5e7eb;
  padding-top: 18px;
} */

.pq-add-agent-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 16px;
}

.pq-add-agent-title {
  margin: 0;
  font-size: 38px;
  line-height: 1.1;
  color: #1f2937;
  font-weight: 700;
}

.pq-add-agent-subtitle {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 16px;
}

.pq-add-agent-close {
  border: 0;
  background: transparent;
  color: #6b7280;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.pq-add-agent-section {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  margin-bottom: 14px;
  overflow: hidden;
  background: #fff;
}

.pq-add-agent-section-head {
  height: 54px;
  border-bottom: 1px solid #eef2f7;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  color: #374151;
  font-size: 30px;
  font-weight: 700;
}

.pq-add-agent-section-head i {
  font-size: 20px;
}

.pq-add-agent-section-head i.orange { color: #ea580c; }
.pq-add-agent-section-head i.green { color: #16a34a; }
.pq-add-agent-section-head i.purple { color: #9333ea; }
.pq-add-agent-section-head i.pink { color: #db2777; }

.pq-add-agent-grid-1,
.pq-add-agent-grid-2,
.pq-add-agent-grid-3 {
  display: grid;
  gap: 14px 16px;
  padding: 16px 14px 14px;
}

.pq-add-agent-grid-1 { grid-template-columns: 1fr; }
.pq-add-agent-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.pq-add-agent-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

.pq-add-agent-form-wrap .pq-text-input,
.pq-add-agent-form-wrap .pq-select-input {
  max-width: 100%;
}

.pq-add-agent-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 14px;
}

.pq-text-input,
.pq-textarea-input,
.pq-select-input {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #111827;
  font-size: 14px;
  outline: none;
}

.pq-text-input {
  height: 46px;
  padding: 0 16px;
  max-width: 605px;
}

.pq-textarea-input {
  min-height: 140px;
  padding: 16px 18px;
  resize: vertical;
  line-height: 1.5;
}

.pq-helper-text {
  margin: 10px 0 0;
  font-size: 13px;
  color: #94a3b8;
}

.pq-upload-box {
  min-height: 290px;
  border: 2px dashed #d1d5db;
  border-radius: 14px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 28px;
  text-align: center;
  cursor: default;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.pq-upload-box.pq-upload-box--drag {
  border-color: #3b82f6;
  background: #f8fafc;
}

.pq-upload-icon {
  font-size: 56px;
  color: #9ca3af;
  line-height: 1;
  margin-bottom: 10px;
}

.pq-upload-text {
  font-size: 16px;
  color: #334155;
  margin-bottom: 6px;
}

.pq-upload-or {
  font-size: 14px;
  color: #94a3b8;
  margin-bottom: 14px;
}

.pq-browse-btn {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #1e293b;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pq-upload-support {
  margin-top: 14px;
  font-size: 13px;
  color: #94a3b8;
}

.pq-artwork-file-list {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  max-width: 605px;
}

.pq-artwork-file-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  margin-bottom: 8px;
  font-size: 14px;
}

.pq-artwork-file-name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #111827;
}

.pq-artwork-file-meta {
  flex-shrink: 0;
  font-size: 12px;
  color: #64748b;
}

.pq-artwork-file-remove {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-artwork-file-remove:hover {
  background: #e2e8f0;
  color: #111827;
}

.pq-designer-group {
  max-width: 340px;
}

.pq-designer-async-wrap {
  position: relative;
  z-index: 50;
}

.pq-designer-async-wrap .pq-designer-rs__control {
  min-height: 46px;
  border-radius: 10px;
  border-color: #cbd5e1;
  box-shadow: none;
  font-size: 14px;
}

.pq-designer-async-wrap .pq-designer-rs__menu {
  z-index: 9999;
}

.pq-designer-async-wrap .pq-designer-rs__control--is-focused {
  border-color: #94a3b8;
  box-shadow: 0 0 0 1px #94a3b8;
}

.pq-designer-async-wrap .pq-designer-rs__indicator-separator {
  display: none;
}

.pq-designer-async-wrap .pq-designer-rs__dropdown-indicator {
  display: flex;
  opacity: 1;
  visibility: visible;
}

.pq-designer-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 46px;
  color: #64748b;
  font-size: 14px;
}

.pq-select-wrap {
  position: relative;
}

.pq-select-input {
  height: 46px;
  padding: 0 42px 0 16px;
  appearance: none;
  cursor: pointer;
}

.pq-select-wrap i {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #475569;
  font-size: 18px;
  pointer-events: none;
}

.pq-message-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.pq-message-label-row .pq-form-label {
  margin-bottom: 0;
}

.pq-emoji-btn {
  border: 0;
  background: transparent;
  color: #334155;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.pq-message-box {
  min-height: 118px;
}

.pq-check-row {
  margin-top: 14px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #334155;
}

.pq-check-row input {
  width: 16px;
  height: 16px;
}

.pq-bottom-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 18px;
  border-top: 1px solid #e5e7eb;
  margin-top: 10px;
}

.pq-agent-details-card {
  border: 1px solid #dbe1ea;
  border-radius: 12px;
  background: #fff;
  padding: 22px 22px 24px;
}

.pq-agent-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-bottom: 22px; */
}

.pq-agent-card-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.pq-agent-edit-btn {
  border: 0;
  background: transparent;
  color: #2563eb;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.pq-agent-grid-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px 56px;
}
/* 
.pq-k {
  margin-bottom: 6px;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 600;
} */
/* 
.pq-v {
  font-size: 15px;
  line-height: 1.4;
  color: #111827;
  font-weight: 600;
} */

.pq-workflow-head {
  padding: 24px 26px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.pq-workflow-head h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #111827;
}

.pq-workflow-body {
  padding: 26px 24px;
}

.pq-workflow-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pq-workflow-row {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 14px;
}

.pq-workflow-row + .pq-workflow-row {
  margin-top: 10px;
}

.pq-workflow-line-col {
  position: relative;
  display: flex;
  justify-content: center;
}

.pq-workflow-line {
  position: absolute;
  top: 38px;
  bottom: -14px;
  width: 2px;
  background: #d1d5db;
}

.pq-workflow-icon {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  position: relative;
  z-index: 1;
}

.pq-workflow-icon.blue {
  background: #dbeafe;
  color: #2563eb;
}

.pq-workflow-icon.purple {
  background: #f3e8ff;
  color: #9333ea;
}

.pq-workflow-icon.green {
  background: #dcfce7;
  color: #16a34a;
}

.pq-workflow-icon.orange {
  background: #ffedd5;
  color: #ea580c;
}

.pq-workflow-icon.mint {
  background: #dcfce7;
  color: #059669;
}

.pq-workflow-content {
  padding-top: 4px;
}

.pq-workflow-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
}

.pq-workflow-detail,
.pq-workflow-assigned {
  font-size: 14px;
  line-height: 1.5;
  color: #6b7280;
}

.pq-edit-status-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  padding: 16px 18px;
}

.pq-edit-status-top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.pq-edit-status-icon {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: #dcfce7;
  color: #059669;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.pq-edit-status-badge {
  height: 30px;
  padding: 0 14px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}

.pq-edit-status-icon.inprogress {
  background: #ede9fe;
  color: #7c3aed;
}

.pq-edit-status-badge.inprogress {
  background: #cffafe;
  color: #0e7490;
}

.pq-edit-status-icon.quoted {
  background: #ffedd5;
  color: #ea580c;
}

.pq-edit-status-badge.quoted {
  background: #ffedd5;
  color: #c2410c;
}

.pq-edit-status-icon.approved {
  background: #dcfce7;
  color: #16a34a;
}

.pq-edit-status-badge.approved {
  background: #d1fae5;
  color: #15803d;
}

.pq-edit-status-icon.completed {
  background: #d1fae5;
  color: #059669;
}

.pq-edit-status-badge.completed {
  background: #e5e7eb;
  color: #374151;
}

.pq-edit-status-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
}

.pq-edit-status-text {
  font-size: 14px;
  color: #6b7280;
}

@media (max-width: 1200px) {
  .pq-create-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .pq-create-header {
    flex-direction: column;
    align-items: stretch;
    padding: 20px 16px;
  }

  .pq-create-layout {
    padding: 16px;
  }

  .pq-create-card-body {
    padding: 18px;
  }

  .pq-agent-grid-details {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .pq-message-label-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .pq-bottom-actions {
    flex-direction: column;
  }

  .pq-footer-cancel-btn,
  .pq-footer-primary-btn,
  .pq-top-cancel-btn,
  .pq-text-input,
  .pq-designer-group {
    width: 100%;
    max-width: 100%;
  }

  .pq-add-agent-title {
    font-size: 28px;
  }

  .pq-add-agent-grid-2,
  .pq-add-agent-grid-3 {
    grid-template-columns: 1fr;
  }
}








/* datatable,view,addandedit files mixed css code  */


 .project-quote-page {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #111827;
}

.pq-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 15px;
}

.pq-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.pq-page-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  color: #111827;
}


.pq-btn {
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.pq-btn-primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.pq-btn-outline {
  background: #fff;
  border-color: #d1d5db;
  color: #374151;
}

.pq-toolbar {
  display: grid;
  grid-template-columns: 1fr 230px;
  gap: 12px;
  margin-bottom: 20px;
}

.pq-input,
.pq-select,
.pq-textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 14px;
  background: #fff;
}

.pq-textarea {
  min-height: 120px;
  resize: vertical;
}

.pq-input:focus,
.pq-select:focus,
.pq-textarea:focus {
  outline: 2px solid rgba(37, 99, 235, 0.2);
  border-color: #2563eb;
}

.pq-stats-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.pq-stat {
  padding: 14px;
  border-left: 4px solid #d1d5db;
}

.pq-stat-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.pq-stat.in-progress {
  border-left-color: #06b6d4;
}

.pq-stat.approved {
  border-left-color: #22c55e;
}

.pq-stat.quoted {
  border-left-color: #f97316;
}

.pq-stat.quote-approved {
  border-left-color: #2563eb;
}

.pq-stat.completed {
  border-left-color: #9ca3af;
}

.pq-stat-value {
  font-size: 28px;
  font-weight: 600;
  line-height: 1;
}

.pq-stat-label {
  margin-top: 6px;
  color: #6b7280;
  font-size: 13px;
}

.pq-stat-icon {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.pq-stat.in-progress .pq-stat-icon {
  background: #cffafe;
  color: #0e7490;
}

.pq-stat.approved .pq-stat-icon {
  background: #dcfce7;
  color: #15803d;
}

.pq-stat.quoted .pq-stat-icon {
  background: #ffedd5;
  color: #c2410c;
}

.pq-stat.quote-approved .pq-stat-icon {
  background: #dbeafe;
  color: #1d4ed8;
}

.pq-stat.completed .pq-stat-icon {
  background: #f3f4f6;
  color: #4b5563;
}

.pq-table-wrap {
  overflow-x: auto;
}

.pq-table {
  width: 100%;
  border-collapse: collapse;
}

.pq-table th,
.pq-table td {
  border-bottom: 1px solid #f1f5f9;
  padding: 12px;
  font-size: 14px;
  text-align: left;
  vertical-align: middle;
}

.pq-table th {
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.pq-table tbody tr:hover {
  background: #f8fafc;
}

.pq-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.25;
}

.pq-badge.in-progress {
  background: #cffafe;
  color: #0e7490;
}

.pq-badge.design-approved {
  background: #dcfce7;
  color: #15803d;
}

.pq-badge.quoted {
  background: #ffedd5;
  color: #c2410c;
}

.pq-badge.quote-approved {
  background: #dbeafe;
  color: #1d4ed8;
}

.pq-badge.completed {
  background: #e5e7eb;
  color: #374151;
}

.pq-action-group {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.pq-icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #334155;
  cursor: pointer;
}

.pq-layout-two-col {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(300px, 1fr);
  gap: 16px;
}

.pq-card-head {
  border-bottom: 1px solid #f1f5f9;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 
.pq-card-head h3 {
  margin: 0;
  font-size: 20px;
} */

.pq-card-body {
  padding: 16px;
}

.pq-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.pq-field-grid .full {
  grid-column: span 2;
}

.pq-field-label {
  margin-bottom: 6px;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
}

.pq-agent-box {
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 8px;
  padding: 14px;
}

.pq-agent-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.pq-agent-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pq-agent-item-icon {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  flex-shrink: 0;
}

.pq-agent-item-icon.user {
  background: #dbeafe;
  color: #2563eb;
}

.pq-agent-item-icon.email {
  background: #e0f2fe;
  color: #0284c7;
}

.pq-agent-item-icon.phone {
  background: #dcfce7;
  color: #16a34a;
}

.pq-agent-item-icon.brokerage {
  background: #ffedd5;
  color: #ea580c;
}

/* .pq-k {
  color: #9ca3af;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
} */

/* .pq-v {
  color: #111827;
  font-size: 14px;
  font-weight: 500;
} */

.pq-split-line {
  border-top: 1px solid #e5e7eb;
  margin: 0 0 14px;
}

/* .pq-address-heading {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
} */

.pq-meta-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.pq-upload-zone {
  border: 2px dashed #d1d5db;
  border-radius: 10px;
  text-align: center;
  color: #6b7280;
  background: #f8fafc;
  padding: 32px 12px;
}

.pq-workflow-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pq-workflow-timeline {
  position: relative;
}

.pq-workflow-timeline::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 8px;
  bottom: 12px;
  width: 2px;
  background: #d1d5db;
}

.pq-workflow-item {
  display: flex;
  gap: 10px;
  padding: 8px 0 14px;
  border-bottom: 0;
  position: relative;
  z-index: 1;
}

.pq-workflow-item:last-child {
  border-bottom: 0;
}

.pq-workflow-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f3f4f6;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-top: 2px;
  border: 1px solid #e5e7eb;
}

.pq-workflow-dot.done {
  background: #dcfce7;
  color: #16a34a;
  border-color: #bbf7d0;
}

.pq-workflow-dot.progress {
  background: #f3e8ff;
  color: #7c3aed;
  border-color: #d8b4fe;
}

.pq-wf-title {
  font-weight: 700;
  color: #1f2937;
  line-height: 1.2;
}

.pq-wf-sub {
  color: #6b7280;
  font-size: 12px;
  margin-top: 2px;
}

.pq-wf-sub.done {
  color: #16a34a;
}

.pq-wf-sub.progress {
  color: #7c3aed;
}



.pq-workflow-item.dim {
  opacity: 0.55;
}

.pq-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

.pq-tab {
  /* padding: 10px 0;
  border: 0; */
  background: transparent;
  /* border-bottom: 2px solid transparent; */
  color: #64748b;
  font-weight: 500;
  cursor: pointer;
}

.pq-tab.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
}

.pq-msg-box {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  min-height: 160px;
  padding: 12px;
}

.pq-msg-input-wrap {
  margin-top: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.pq-msg-input {
  border: 0;
  width: 100%;
  padding: 14px;
  min-height: 100px;
  resize: vertical;
}

.pq-msg-actions {
  border-top: 1px solid #f1f5f9;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pq-muted {
  color: #6b7280;
}

.pq-view-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
}

.pq-view-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pq-view-title {
  margin: 0;
  font-size: 21px;
  font-weight: 500;
}

.pq-back-link {
  border: 0;
  background: transparent;
  color: #334155;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
}

.pq-status-pill {
  background: #cffafe;
  color: #0e7490;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

/* .pq-additional-btn {
  width: 100%;
  margin-top: 14px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 8px;
  height: 38px;
  color: #334155;
} */

/* Duplicate .pq-tabs-with-right / .pq-mute / .pq-convo-* (canonical: projectandquote-view.css)
.pq-tabs-with-right { align-items: center; background: linear-gradient(to right, #eff6ff, #f8faff); margin: -16px -16px 16px; padding: 0 16px; border-bottom: 1px solid #dbeafe; }
.pq-mute-btn { margin-left: auto; border: 0; background: transparent; color: #64748b; }
.pq-convo-list { max-height: 390px; overflow: auto; padding-right: 2px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px; }
.pq-convo-item { margin-bottom: 14px; padding: 0; border: 0; border-radius: 0; background: transparent; }
.pq-convo-top { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-bottom: 8px; }
.pq-convo-user { display: flex; align-items: center; gap: 8px; }
.pq-convo-avatar { width: 34px; height: 34px; border-radius: 50%; background: #e5e7eb; color: #6b7280; display: inline-flex; align-items: center; justify-content: center; font-size: 16px; }
.pq-convo-avatar.designer { background: #dbeafe; color: #2563eb; }
.pq-convo-avatar.agent { background: #e5e7eb; color: #6b7280; }
.pq-convo-role { font-size: 12px; color: #4b5563; background: #f3f4f6; border-radius: 999px; padding: 1px 8px; }
.pq-convo-time { color: #6b7280; font-size: 12px; }
.pq-convo-text { margin: 0; color: #334155; }
.pq-convo-bubble-wrap { margin-top: 0; border: 1px solid #e6ebf2; border-radius: 10px; background: #f9fafb; padding: 12px 14px; }
*/

.pq-attachments {
  margin-top: 10px;
  display: grid;
  gap: 8px;
}

.pq-attachment {
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  padding: 8px 10px;
  font-size: 13px;
  color: #334155;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.pq-attachment-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.pq-attachment-name {
  font-weight: 600;
  color: #1f2937;
}

.pq-proof-badge {
  background: #e0e7ff;
  color: #4338ca;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
}

.pq-btn-sm {
  height: 34px;
  padding: 6px 12px;
  font-size: 13px;
}

.pq-convo-separator {
  border-top: 1px solid #e5e7eb;
  margin: 12px 0;
}

.pq-attached-list {
  padding: 0 12px 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pq-attached-pill {
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.pq-attach-label {
  cursor: pointer;
  margin-bottom: 0;
}

.pq-sticky-side {
  position: sticky;
  top: 16px;
  align-self: start;
}

.pq-side-section {
  border-top: 1px solid #e5e7eb;
  margin-top: 12px;
  padding-top: 14px;
}

.pq-side-title {
  margin: 0 0 10px;
  font-size: 14px;
}

.pq-side-box {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 12px;
  background: #fff;
}

.pq-side-box-title {
  font-size: 13px;
  color: #1e3a8a;
  font-weight: bold;
  margin-bottom: 8px;
  background: linear-gradient(to right, #eff6ff, #f5f8ff);
}

.pq-radio-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 2px;
  border-top: 1px solid #f1f5f9;
  border-radius: 6px;
  transition: background 0.12s;
}

.pq-radio-row:hover {
  background: #f8faff;
}

.pq-radio-row.selected {
  background: #eff6ff;
}

.pq-radio-row:first-of-type {
  border-top: 0;
}

.pq-radio-row small {
  margin-left: auto;
  color: #64748b;
}

.pq-proof-file-chip {
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 12px;
  padding: 1px 8px;
}

.pq-full-btn {
  width:92%;
  margin-top: 8px;
  justify-content: center;
}

.pq-btn-disabled {
  color: #9ca3af;
  border-color: #e5e7eb;
  background: #f8fafc;
}

.pq-required {
  color: #ef4444;
}

.pq-order-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.pq-order-row i {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 16px;
}

.pq-cancel-btn {
  color: #b91c1c;
  border-color: #fecaca;
  background: #fff1f2;
}

.pq-ref-head {
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
  margin-bottom: 18px;
}

.pq-ref-back {
  margin-top: 3px;
}

.pq-ref-divider {
  width: 1px;
  height: 20px;
  background: #d1d5db;
}

.pq-ref-title {
  font-size: 28px;
}

.pq-actions-wrap {
  position: relative;
}

.pq-ref-actions {
  min-width: 110px;
  justify-content: space-between;
}

.pq-actions-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  width: 160px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.1);
  z-index: 20;
  overflow: hidden;
}

.pq-actions-menu button {
  width: 100%;
  border: 0;
  background: #fff;
  text-align: left;
  padding: 9px 12px;
  color: #334155;
}

.pq-actions-menu button:hover {
  background: #f8fafc;
}

.pq-actions-menu i {
  margin-right: 6px;
}

/* .pq-ref-card-head-blue {
  background: linear-gradient(to right, #eff6ff, #fff);
  border-bottom-color: #e6edf8;
} */

.pq-ref-card-head-indigo {
  background: linear-gradient(to right, #eef2ff, #fff);
  border-bottom-color: #e9e8fb;
}

/* .pq-ref-head-title {
  font-size: 17px !important;
  color: #1e3a8a;
} */

/* .pq-expand-details {
  border-top: 1px solid #e5e7eb;
  margin-top: 14px;
  padding-top: 14px;
} */

.pq-shared-files {
  display: grid;
  gap: 12px;
}

.pq-proof-group {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.pq-proof-group-head {
  background: #eef2ff;
  color: #4f46e5;
  font-weight: 600;
  font-size: 12px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pq-proof-group-head.plain {
  background: #f8fafc;
  color: #475569;
}

.pq-proof-chip {
  border: 1px solid #a5b4fc;
  background: #fff;
  border-radius: 999px;
  padding: 2px 7px;
}

.pq-file-row {
  display: grid;
  grid-template-columns: 40px 1fr auto;
  gap: 25px;
  padding: 12px;
  border-top: 1px solid #f1f5f9;
  align-items: center;
}

.pq-file-type {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #7f1d1d;
  background: #fee2e2;
}

.pq-file-type.jpg {
  color: #1e40af;
  background: #dbeafe;
}

.pq-file-meta {
  min-width: 0;
}

.pq-file-name {
  font-weight: 600;
  color: #111827;
}

.pq-file-sub {
  color: #64748b;
  font-size: 12px;
}

.pq-file-actions {
  display: flex;
  gap: 8px;
  color: #94a3b8;
}

.pq-side-section-green {
  border-top-color: #dcfce7;
}

.pq-side-section-green .pq-side-title {
  color: #166534;
  font-weight: 700;
}

@media (max-width: 1100px) {
  .pq-layout-two-col {
    grid-template-columns: 1fr;
  }

  .pq-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .pq-toolbar {
    grid-template-columns: 1fr;
  }

  .pq-field-grid,
  .pq-agent-grid,
  .pq-meta-row {
    grid-template-columns: 1fr;
  }

  .pq-field-grid .full {
    grid-column: span 1;
  }

  .pq-stats-grid {
    grid-template-columns: 1fr;
  }

  .pq-view-title {
    font-size: 21px;
  }
}

/* Google Places: custom two-line suggestion list (AutocompleteService) */
.pq-gac-wrap {
  position: relative;
  z-index: 5;
}

.pq-gac-dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  margin: 0;
  padding: 4px 0;
  list-style: none;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.12);
}

.pq-gac-item {
  padding: 10px 14px 10px 12px;
  cursor: pointer;
  border-left: 4px solid transparent;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pq-gac-item:hover,
.pq-gac-item--active {
  background: #eff6ff;
  border-left-color: #2563eb;
}

.pq-gac-main {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
}

.pq-gac-secondary {
  font-size: 13px;
  font-weight: 400;
  color: #64748b;
  line-height: 1.35;
}
`, "",{"version":3,"sources":["webpack://./src/pages/signage/projectandquote.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sCAAsC,cAAc,EAAE;AACtD,qCAAqC,cAAc,EAAE;AACrD,sCAAsC,cAAc,EAAE;AACtD,oCAAoC,cAAc,EAAE;;AAEpD;;;EAGE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;AACF;;;AAGA,sDAAsD;;AAEtD;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;;AAGA,sDAAsD;;AAEtD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE,uDAAuD;EACvD,4BAA4B;AAC9B;AACA;;;;;;;;;GASG;;;;AAIH,kDAAkD;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;;AAIA,gEAAgE;;AAEhE;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;;AAErE;;;;;GAKG;AACH;;;;;;GAMG;;AAEH;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;GAUG;;AAEH;;;EAGE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;;;;;;;GAQG;;AAEH;;;;;;;;;;;;;CAaC;;AAED,qDAAqD;;;AAGrD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;AAGA,wEAAwE;;AAExE;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB,cAAc,EAAE;AAClC,sBAAsB,cAAc,EAAE;;;AAGtC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,wBAAwB;;;AAGxB;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;GAQG;;AAEH;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;;;;;;GAMG;;AAEH;;;;;GAKG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;;;;;;;CASC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;GAMG;;AAEH;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,6BAA6B;EAC7B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;;IAGE,WAAW;IACX,uBAAuB;EACzB;AACF;;;AAGA,2CAA2C;;;AAG3C;EACE,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,2GAA2G;AAC3G;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,sCAAsC,cAAc,EAAE;AACtD,qCAAqC,cAAc,EAAE;AACrD,sCAAsC,cAAc,EAAE;AACtD,oCAAoC,cAAc,EAAE;;AAEpD;;;EAGE,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA,uBAAuB,0BAA0B,EAAE;AACnD,uBAAuB,gDAAgD,EAAE;AACzE,uBAAuB,gDAAgD,EAAE;;AAEzE;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;;;;;;;;GAQG;AACH;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;IAKE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;;;;;;;;AASA,oDAAoD;;;CAGnD;EACC,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;;;GAIG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;GAKG;;AAEH;;;;GAIG;;AAEH;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE;cACY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;GAQG;;AAEH;;;;;;;;;;;;;;CAcC;;AAED;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;;;GAGG;;AAEH;;;;GAIG;;AAEH;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["\n.pq-create-page {\n  background: #f9fafb;\n  min-height: 100vh;\n}\n\n.pq-create-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  /* margin: 18px 18px 0; */\n  padding: 22px 24px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n}\n\n.pq-create-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n  line-height: 1.35;\n}\n\n.pq-create-subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pq-create-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 16px;\n  padding: 16px 18px 24px;\n  align-items: start;\n}\n\n.pq-main-panel,\n.pq-side-panel {\n  min-width: 0;\n}\n\n.pq-create-card,\n.pq-workflow-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.pq-create-card-body {\n  padding: 24px;\n}\n\n.pq-workflow-card-head {\n  padding: 16px 18px;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-workflow-card-body {\n  padding: 18px;\n}\n\n.pq-top-cancel-btn,\n.pq-footer-cancel-btn {\n  height: 40px;\n  padding: 0 18px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #1e293b;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-footer-primary-btn {\n  height: 40px;\n  padding: 0 20px;\n  border: 0;\n  background: #2563eb;\n  color: #fff;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-footer-primary-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pq-bottom-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 18px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pq-add-agent-form-wrap {\n  /* border: 1px solid #e5e7eb; */\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.pq-add-agent-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 18px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.pq-add-agent-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-add-agent-subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pq-add-agent-close {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  border-radius: 10px;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-add-agent-section {\n  border-top: 1px solid #e5e7eb;\n}\n\n.pq-add-agent-section:first-of-type {\n  border-top: 0;\n}\n\n.pq-add-agent-section-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #334155;\n  background: #fff;\n}\n\n.pq-add-agent-section-head i.orange { color: #f97316; }\n.pq-add-agent-section-head i.green { color: #22c55e; }\n.pq-add-agent-section-head i.purple { color: #a855f7; }\n.pq-add-agent-section-head i.pink { color: #ec4899; }\n\n.pq-add-agent-grid-1,\n.pq-add-agent-grid-2,\n.pq-add-agent-grid-3 {\n  display: grid;\n  gap: 18px;\n  padding: 0 18px 18px;\n}\n\n.pq-add-agent-grid-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.pq-add-agent-grid-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.pq-form-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-text-input,\n.pq-textarea,\n.pq-select-input {\n  width: 100%;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  color: #111827;\n  font-size: 14px;\n}\n\n.pq-text-input,\n.pq-select-input {\n  height: 42px;\n  padding: 0 14px;\n}\n\n.pq-textarea {\n  min-height: 130px;\n  padding: 14px 16px;\n  resize: vertical;\n  line-height: 1.6;\n}\n\n.pq-text-input::placeholder,\n.pq-textarea::placeholder {\n  color: #94a3b8;\n}\n\n.pq-text-input:focus,\n.pq-textarea:focus,\n.pq-select-input:focus {\n  outline: none;\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.15);\n}\n\n.pq-upload-zone {\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n  background: #f8fafc;\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.pq-upload-zone.drag-over {\n  border-color: #60a5fa;\n  background: #eff6ff;\n}\n\n.pq-upload-icon {\n  font-size: 44px;\n  color: #9ca3af;\n  margin-bottom: 12px;\n}\n\n.pq-upload-title {\n  font-size: 15px;\n  color: #334155;\n  margin-bottom: 6px;\n}\n\n.pq-upload-or {\n  font-size: 14px;\n  color: #94a3b8;\n  margin-bottom: 14px;\n}\n\n.pq-upload-hint {\n  margin-top: 12px;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.pq-workflow-list-wrap {\n  position: relative;\n}\n\n.pq-workflow-row {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  padding-bottom: 22px;\n}\n\n.pq-workflow-left {\n  position: relative;\n  width: 32px;\n  flex-shrink: 0;\n}\n\n.pq-workflow-line {\n  position: absolute;\n  left: 15px;\n  top: 34px;\n  bottom: -10px;\n  width: 2px;\n  background: #d1d5db;\n}\n\n.pq-workflow-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.pq-workflow-icon.blue { background: #dbeafe; color: #2563eb; }\n.pq-workflow-icon.purple { background: #f3e8ff; color: #9333ea; }\n.pq-workflow-icon.green { background: #dcfce7; color: #16a34a; }\n.pq-workflow-icon.orange { background: #ffedd5; color: #ea580c; }\n.pq-workflow-icon.mint { background: #dcfce7; color: #059669; }\n\n.pq-workflow-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.pq-workflow-detail,\n.pq-workflow-assigned {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n@media (max-width: 1200px) {\n  .pq-create-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .pq-create-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pq-add-agent-grid-2,\n  .pq-add-agent-grid-3 {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-bottom-actions {\n    flex-direction: column;\n  }\n\n  .pq-top-cancel-btn,\n  .pq-footer-cancel-btn,\n  .pq-footer-primary-btn {\n    width: 100%;\n  }\n}\n\n\n/* Replace your top-level view layout CSS with this: */\n\n.project-quote-page.pq-page-shell {\n  /* background: #f8fafc; */\n  min-height: 100vh;\n  padding: 20px;\n}\n\n.pq-view-head.pq-ref-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n  padding: 22px 24px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n}\n\n.pq-layout-two-col {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 18px;\n  align-items: start;\n}\n\n.pq-main-col {\n  min-width: 0;\n}\n\n.pq-sticky-side {\n  position: sticky;\n  top: 20px;\n}\n\n\n/* Make all cards look like the reference card style */\n\n.pq-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n.pq-section-card {\n  margin-bottom: 18px;\n}\n\n.pq-card-head {\n  padding: 14px 18px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.pq-card-body {\n  padding: 20px 22px;\n}\n\n/* .pq-ref-card-head-blue {\n  background: linear-gradient(to right, #eff6ff, #ffffff);\n  border-bottom-color: #dbeafe;\n} */\n\n.pq-ref-card-head-indigo {\n  background: linear-gradient(to right, #eef2ff, #ffffff);\n  border-bottom-color: #e0e7ff;\n}\n/* \n.pq-ref-head-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 18px !important;\n  font-weight: 700;\n  color: #1e3a8a;\n} */\n\n\n\n/* Adjust the page header to match the reference */\n\n.pq-view-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pq-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0;\n}\n\n.pq-ref-divider {\n  width: 1px;\n  height: 20px;\n  background: #d1d5db;\n}\n\n.pq-view-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-status-pill {\n  display: inline-flex;\n  align-items: center;\n  /* height: 30px; */\n  padding: 0 12px;\n  border-radius: 999px;\n  background: #e0e7ff;\n  color: #3730a3;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n\n\n/* Make the agent info section look cleaner like the reference */\n\n.pq-agent-grid-top {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px 18px;\n}\n\n.pq-agent-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px;\n  /* border: 1px solid #e5e7eb; */\n  border-radius: 12px;\n  /* background: #f8fafc; */\n}\n\n.pq-agent-item-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.pq-agent-item-icon.user { background: #eff6ff; color: #2563eb; }\n.pq-agent-item-icon.email { background: #eef2ff; color: #4f46e5; }\n.pq-agent-item-icon.phone { background: #ecfeff; color: #0891b2; }\n.pq-agent-item-icon.brokerage { background: #f5f3ff; color: #7c3aed; }\n\n/* .pq-k {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 4px;\n} */\n/* \n.pq-v {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  line-height: 1.5;\n} */\n\n.pq-block-value {\n  margin-top: 4px;\n}\n\n/* .pq-additional-btn {\n  margin-top: 16px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n  border-radius: 10px;\n  height: 38px;\n  padding: 0 14px;\n  font-size: 14px;\n  font-weight: 600;\n} */\n\n.pq-agent-grid-bottom,\n.pq-agent-address-grid,\n.pq-meta-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.pq-split-line {\n  border-top: 1px solid #e5e7eb;\n  margin: 18px 0;\n}\n\n/* .pq-address-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n} */\n\n/* Make conversation and shared files section match reference\n * DUPLICATE class names also defined in projectandquote-view.css (project view).\n * Kept commented to avoid fighting the view page styles.\n *\n.pq-conversation-card-body { padding: 0; }\n.pq-tabs-with-right { display: flex; align-items: center; gap: 0; border-bottom: 1px solid #e5e7eb; padding: 0 18px; }\n.pq-tab { height: 52px; padding: 0 16px; border: 0; background: transparent; color: #64748b; font-size: 14px; font-weight: 600; border-bottom: 2px solid transparent; }\n.pq-tab.active { color: #2563eb; border-bottom-color: #2563eb; }\n.pq-mute-btn { margin-left: auto; border: 1px solid #cbd5e1; background: #fff; color: #334155; border-radius: 10px; height: 36px; padding: 0 12px; font-size: 13px; font-weight: 600; }\n.pq-convo-list, .pq-shared-files { padding: 18px; }\n.pq-convo-item { border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; background: #fff; }\n.pq-convo-item + .pq-convo-item { margin-top: 14px; }\n... (truncated in comment — see git history if needed)\n*/\n\n/* Make shared files section match reference better */\n\n\n.pq-proof-group {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.pq-proof-group-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #eef2ff;\n  color: #4338ca;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.pq-proof-group-head.plain {\n  background: #f8fafc;\n  color: #475569;\n}\n\n.pq-proof-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #c7d2fe;\n  color: #3730a3;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pq-file-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px;\n  border-top: 1px solid #eef2f7;\n}\n\n.pq-file-type {\n  min-width: 48px;\n  height: 28px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.pq-file-meta {\n  min-width: 0;\n  flex: 1;\n}\n\n.pq-file-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-file-sub {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.pq-file-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n\n/* . Match the right sidebar workflow + quick action card to reference */\n\n.pq-sidebar-body {\n  padding: 18px;\n}\n\n.pq-workflow-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pq-workflow-item {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  padding-bottom: 20px;\n}\n\n.pq-workflow-item:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  left: 14px;\n  top: 34px;\n  bottom: 0;\n  width: 2px;\n  background: #e5e7eb;\n}\n\n.pq-workflow-dot {\n  position: relative;\n  z-index: 1;\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pq-workflow-dot.done {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.pq-workflow-dot.progress {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.pq-workflow-dot.pending {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n.pq-wf-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-wf-sub {\n  font-size: 13px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.pq-wf-sub.done { color: #16a34a; }\n.pq-wf-sub.progress { color: #7c3aed; }\n\n\n.pq-side-section {\n  margin-top: 18px;\n}\n\n.pq-side-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #166534;\n}\n\n.pq-side-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  padding: 14px;\n  margin-bottom: 14px;\n}\n\n.pq-side-box-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 800;\n  color: #334155;\n  letter-spacing: 0.04em;\n}\n\n.pq-radio-row,\n.pq-order-option {\n  display: block;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px;\n  background: #fff;\n  margin-bottom: 10px;\n}\n\n.pq-radio-row.selected,\n.pq-order-option:has(input:checked) {\n  border-color: #93c5fd;\n  background: #f8fbff;\n}\n\n/* view file css code  */\n\n\n.pq-page-shell {\n  padding: 20px 22px 28px;\n  background: #f9fafb;\n}\n\n.pq-main-col,\n.pq-section-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.pq-section-card {\n  margin-bottom: 14px;\n}\n\n.pq-ref-head {\n  padding-bottom: 14px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 16px;\n}\n\n.pq-ref-title {\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #111827;\n}\n\n\n.pq-page-subtitle strong {\n  color: #111827;\n  font-weight: 700;\n}\n\n.pq-back-link {\n  font-size: 14px;\n  font-weight: 500;\n  gap: 6px;\n}\n\n.pq-ref-divider {\n  width: 1px;\n  height: 28px;\n  background: #d1d5db;\n}\n\n.pq-status-pill {\n  background: #cffafe;\n  color: #0e7490;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 999px;\n}\n\n.pq-ref-actions {\n  height: 44px;\n  min-width: 152px;\n  border-radius: 12px;\n  font-size: 14px;\n  padding: 0 16px;\n}\n\n.pq-actions-wrap {\n  position: relative;\n}\n\n.pq-actions-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 170px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);\n  z-index: 20;\n  overflow: hidden;\n}\n\n.pq-actions-menu button {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 12px 14px;\n  text-align: left;\n  font-size: 14px;\n  color: #334155;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-actions-menu button:hover {\n  background: #f8fafc;\n}\n\n.pq-layout-two-col {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) 520px;\n  gap: 16px;\n  align-items: start;\n}\n\n.pq-card {\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  box-shadow: none;\n}\n\n.pq-card-head {\n  min-height: 44px;\n  padding: 12px 16px;\n}\n\n/* .pq-ref-card-head-blue {\n  background: #eef4ff;\n} */\n\n.pq-ref-card-head-indigo {\n  background: #eef2ff;\n}\n\n/* .pq-ref-head-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: #1d4ed8;\n} */\n\n/* .pq-ref-card-head-indigo .pq-ref-head-title {\n  color: #3730a3;\n} */\n\n.pq-card-body {\n  padding: 18px 16px;\n}\n\n.pq-agent-grid-top1 {\n  gap: 0px 27px;\n}\n\n.pq-agent-grid-bottom {\n  margin-top: 2px;\n  gap: 18px 26px;\n}\n\n.pq-agent-address-grid {\n  margin-top: 10px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px 26px;\n}\n\n/* .pq-k {\n  font-size: 11px;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 5px;\n} */\n\n/* .pq-v {\n  font-size: 15px;\n  line-height: 1.45;\n  font-weight: 600;\n  color: #111827;\n} */\n\n.pq-block-value {\n  margin-bottom: 16px;\n}\n\n/* .pq-additional-btn {\n  margin-top: 16px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-weight: 500;\n  background: #fff;\n} */\n\n.pq-space-top {\n  margin-top: 14px;\n}\n\n/* .pq-address-heading {\n  font-size: 12px;\n  color: #334155;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  margin-bottom: 12px;\n} */\n\n.pq-meta-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n}\n\n/* Duplicate conversation chrome (canonical: projectandquote-view.css)\n.pq-conversation-card-body { padding: 0; }\n.pq-tabs-with-right { margin: 0; padding: 0 16px; min-height: 42px; display: flex; align-items: center; gap: 18px; background: #eff6ff; border-bottom: 1px solid #dbeafe; }\n.pq-tab { display: inline-flex; align-items: center; gap: 6px; height: 42px; font-size: 14px; font-weight: 500; }\n.pq-tab.active { color: #2563eb; border-bottom: 2px solid #2563eb; }\n.pq-mute-btn { margin-left: auto; font-size: 14px; display: inline-flex; align-items: center; gap: 6px; }\n.pq-convo-list { margin: 12px 16px 14px; padding: 14px; max-height: 540px; overflow-y: auto; border: 1px solid #e5e7eb; border-radius: 12px; background: #f8fafc; }\n.pq-convo-item { margin-bottom: 18px; }\n.pq-convo-item:last-child { margin-bottom: 0; }\n*/\n\n.pq-convo-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.pq-convo-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-convo-user-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pq-convo-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #e5e7eb;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.pq-convo-avatar.agent {\n  background: #e5e7eb;\n  color: #64748b;\n}\n\n.pq-convo-avatar.designer {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.pq-convo-role {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.pq-convo-time {\n  font-size: 13px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.pq-convo-bubble-wrap {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  /* padding: 16px; */\n}\n\n\n.pq-attachments {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pq-attachment {\n  min-height: 54px;\n  border: 1px solid #dbe3ef;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 10px 12px;\n}\n\n.pq-attachment-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pq-attachment-fileicon {\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.pq-attachment-content {\n  min-width: 0;\n}\n\n.pq-attachment-topline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pq-attachment-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-attachment-download {\n  border: 0;\n  background: transparent;\n  color: #64748b;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pq-attachment-download:hover {\n  background: #f8fafc;\n}\n\n.pq-proof-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #ede9fe;\n  color: #4f46e5;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* .pq-convo-input-wrap {\n  margin: 0 16px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #fff;\n} */\n\n.pq-msg-input {\n  width: 100%;\n  min-height: 114px;\n  border: 0;\n  resize: vertical;\n  padding: 16px;\n  font-size: 14px;\n}\n\n.pq-msg-input:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.pq-attached-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 0 16px 14px;\n}\n\n.pq-attached-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.pq-msg-actions {\n  min-height: 60px;\n  border-top: 1px solid #e5e7eb;\n  background: #f8fafc;\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pq-msg-actions--composer {\n  flex-wrap: wrap;\n  gap: 10px 12px;\n  justify-content: flex-start;\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.pq-msg-actions--composer .pq-send-btn {\n  margin-left: auto;\n}\n\n.pq-msg-actions--composer .pq-send-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  pointer-events: auto;\n}\n\n.pq-msg-toolbar-divider {\n  width: 1px;\n  height: 28px;\n  background: #e5e7eb;\n  flex-shrink: 0;\n}\n\n.pq-design-proof-block {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n}\n\n.pq-design-proof-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  white-space: nowrap;\n}\n\n.pq-design-proof-toggles {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.pq-toggle-yesno {\n  min-width: 48px;\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.pq-toggle-yesno:hover {\n  border-color: #94a3b8;\n  background: #f8fafc;\n}\n\n.pq-toggle-yesno.active {\n  border-color: #3b82f6;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.pq-msg-toolbar-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n/* .pq-emoji-inline-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 34px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n} */\n\n.pq-emoji-inline-btn:hover {\n  background: #e2e8f0;\n  color: #334155;\n}\n\n.pq-attached-count-text {\n  white-space: nowrap;\n}\n\n.pq-attached-pill--file {\n  max-width: 100%;\n  gap: 8px;\n}\n\n.pq-attached-pill-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 200px;\n  color: #1e40af;\n}\n\n.pq-attached-pill-size {\n  color: #3b82f6;\n  font-weight: 500;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.pq-attached-pill-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 2px;\n  padding: 0;\n  width: 22px;\n  height: 22px;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: #1d4ed8;\n  cursor: pointer;\n}\n\n.pq-attached-pill-remove:hover {\n  background: rgba(59, 130, 246, 0.15);\n}\n\n.pq-convo-top-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-reply-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #475569;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pq-reply-btn:hover {\n  border-color: #c0cedf;\n  color: #1e293b;\n}\n\n.pq-reply-inline {\n  border-left: 3px solid #2563eb;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 8px 10px;\n  margin-bottom: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pq-reply-inline strong {\n  font-size: 12px;\n  color: #1d4ed8;\n}\n\n.pq-reply-inline span {\n  font-size: 12px;\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pq-replying-bar {\n  margin: 10px 14px 0;\n  border-left: 3px solid #2563eb;\n  background: #f1f5f9;\n  border-radius: 8px;\n  padding: 8px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.pq-replying-meta {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pq-replying-meta strong {\n  font-size: 12px;\n  color: #1d4ed8;\n}\n\n.pq-replying-meta span {\n  font-size: 12px;\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pq-replying-cancel {\n  border: 0;\n  background: transparent;\n  color: #64748b;\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-replying-cancel:hover {\n  background: #e2e8f0;\n}\n\n.pq-last-message-btn {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  text-align: left;\n  cursor: pointer;\n  box-shadow:none;\n}\n\n.pq-last-message-text {\n  font-size: 14px;\n  font-weight: 400;\n  color: #334155;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pq-last-message-text--unread {\n  font-weight: 700;\n}\n\n.pq-last-message-btn:hover .pq-last-message-text {\n  color: #1d4ed8;\n  text-decoration: none;\n}\n\n.pq-live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #3b82f6;\n  box-shadow: 0 0 0 rgba(59, 130, 246, 0.6);\n  animation: pq-live-pulse 1.4s infinite;\n  flex-shrink: 0;\n}\n\n.pq-live-dot--approved {\n  background: #22c55e;\n  box-shadow: 0 0 0 rgba(34, 197, 94, 0.6);\n  animation: pq-live-pulse-approved 1.4s infinite;\n}\n\n@keyframes pq-live-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.55);\n  }\n  70% {\n    box-shadow: 0 0 0 8px rgba(59, 130, 246, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);\n  }\n}\n\n@keyframes pq-live-pulse-approved {\n  0% {\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);\n  }\n  70% {\n    box-shadow: 0 0 0 7px rgba(34, 197, 94, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);\n  }\n}\n\n.pq-msg-actions-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-btn-sm {\n  height: 38px;\n  padding: 0 14px;\n}\n\n.pq-send-btn {\n  height: 38px;\n  min-width: 92px;\n  border-radius: 10px;\n}\n\n.pq-sidebar-body {\n  padding: 0;\n}\n\n.pq-workflow-list {\n  padding: 18px 18px 10px;\n}\n\n.pq-workflow-timeline::before {\n  left: 32px;\n  top: 34px;\n  bottom: 28px;\n}\n\n.pq-workflow-item {\n  gap: 14px;\n  padding: 8px 0 18px;\n}\n\n.pq-workflow-dot {\n  width: 30px;\n  height: 30px;\n  margin-top: 2px;\n}\n\n.pq-wf-title {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n\n\n.pq-side-section {\n  border-top: 1px solid #dcfce7;\n  margin-top: 8px;\n  /* padding: 14px 18px 18px; */\n}\n\n.pq-side-section-green {\n  background: linear-gradient(to bottom, #f0fdf4 0, #ffffff 70px);\n}\n\n.pq-side-title {\n  margin: 0 0 12px;\n  color: #166534;\n  font-size: 18px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: linear-gradient(to right, #f0fdf4, #f8faff);\n}\n\n.pq-side-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.pq-side-box:last-child {\n  margin-bottom: 0;\n}\n\n.pq-side-box-title {\n  min-height: 42px;\n  padding: 8px 14px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #374151;\n  letter-spacing: 0.04em;\n}\n\n.pq-radio-row {\n  min-height: 60px;\n  display: grid;\n  grid-template-columns: 18px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  cursor: pointer;\n}\n\n.pq-radio-row:last-of-type {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.pq-radio-row.selected {\n  background: #eff6ff;\n}\n\n.pq-radio-row input {\n  margin: 0;\n}\n\n.pq-proof-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pq-proof-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-proof-file-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  font-size: 12px;\n  color: #4b5563;\n}\n\n.pq-full-btn {\n  width: calc(100% - 28px);\n  margin: 14px;\n  height: 44px;\n  border-radius: 10px;\n}\n\n.pq-btn-disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.pq-required {\n  color: #ef4444;\n}\n\n.pq-order-option {\n  min-height: 72px;\n  display: grid;\n  grid-template-columns: 18px minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  cursor: pointer;\n}\n\n.pq-order-option input {\n  margin: 0;\n}\n\n.pq-order-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pq-order-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.pq-order-row strong {\n  display: block;\n  font-size: 14px;\n  color: #111827;\n  margin-bottom: 2px;\n}\n\n.pq-order-row small {\n  display: block;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.pq-cancel-btn {\n  color: #dc2626;\n  border-color: #fecaca;\n  background: #fff5f5;\n}\n\n.pq-cancel-btn:hover {\n  background: #fef2f2;\n}\n\n.pq-sticky-side {\n  position: sticky;\n  top: 18px;\n}\n\n@media (max-width: 1200px) {\n  .pq-layout-two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-sticky-side {\n    position: static;\n  }\n}\n\n@media (max-width: 768px) {\n  .pq-page-shell {\n    padding: 14px;\n  }\n\n  .pq-view-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pq-view-title-row {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .pq-ref-divider {\n    display: none;\n  }\n\n  .pq-agent-grid,\n  .pq-meta-row,\n  .pq-agent-address-grid {\n    grid-template-columns: 1fr;\n  }\n\n\n  .pq-convo-top {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .pq-msg-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .pq-send-btn,\n  .pq-msg-actions-left,\n  .pq-attach-label {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n\n/* addandedit project and quote css code  */\n\n\n.pq-create-page {\n  background: #f8fafc;\n  min-height: 100vh;\n  padding: 0;\n}\n\n.pq-create-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 28px 28px 24px;\n  border-top: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.pq-create-title {\n  margin: 0;\n  font-size: 20px;\n  line-height: 1.3;\n  font-weight: 500;\n  color: #111827;\n}\n\n.pq-create-subtitle {\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #475569;\n}\n\n.pq-top-cancel-btn,\n.pq-footer-cancel-btn {\n  height: 40px;\n  padding: 0 20px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #1e293b;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-footer-primary-btn {\n  height: 44px;\n  padding: 0 22px;\n  border: 0;\n  background: #2563eb;\n  color: #fff;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: none;\n}\n\n.pq-create-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 480px;\n  gap: 22px;\n  padding: 32px 28px 28px;\n  align-items: start;\n}\n\n.pq-create-card,\n.pq-workflow-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.pq-create-card-body {\n  padding: 26px 34px 28px;\n}\n\n.pq-form-group {\n  margin-bottom: 24px;\n}\n\n.pq-form-label {\n  display: block;\n  margin-bottom: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-light-text {\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.pq-search-input-wrap {\n  position: relative;\n  max-width: 605px;\n  margin-bottom: 14px;\n}\n\n.pq-search-input-wrap i {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 20px;\n  color: #94a3b8;\n}\n\n.pq-search-input {\n  width: 100%;\n  height: 48px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  padding: 0 16px 0 50px;\n  font-size: 14px;\n  color: #111827;\n  outline: none;\n  background: #fff;\n}\n\n.pq-search-input::placeholder {\n  color: #94a3b8;\n}\n\n.pq-add-agent-btn {\n  height: 40px;\n  padding: 0 18px;\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #2563eb;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n/* Agent / brokerage search: SearchBrokerageAgentTeam (users/:customerGroupId/created-or-linked-detailed) */\n.pq-agent-picker-wrap {\n  position: relative;\n  max-width: 605px;\n  margin-bottom: 14px;\n  z-index: 6;\n}\n\n.pq-search-bat-project.pq-agent-picker-wrap {\n  max-width: min(100%, 720px);\n}\n\n.pq-search-input-wrap--picker.pq-search-input-wrap--clearable .pq-search-input {\n  padding-right: 44px;\n}\n\n.pq-agent-picker-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.pq-agent-picker-clear:hover {\n  background: #f1f5f9;\n  color: #111827;\n}\n\n.pq-agent-picker-dropdown {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 6px);\n  max-height: 320px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);\n}\n\n.pq-agent-picker-status {\n  padding: 14px 16px;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pq-agent-picker-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: none;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n}\n\n.pq-agent-picker-row:last-of-type {\n  border-bottom: none;\n}\n\n.pq-agent-picker-row:hover {\n  background: #f8fafc;\n}\n\n.pq-agent-picker-avatar {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0369a1;\n  font-size: 13px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-agent-picker-text {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pq-agent-picker-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.pq-agent-picker-sub {\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.pq-agent-picker-more {\n  width: 100%;\n  padding: 12px 14px;\n  border: none;\n  border-top: 1px solid #f1f5f9;\n  background: #f8fafc;\n  color: #2563eb;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-agent-picker-more:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* .pq-add-agent-form-wrap {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 18px;\n} */\n\n.pq-add-agent-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: flex-start;\n  margin-bottom: 16px;\n}\n\n.pq-add-agent-title {\n  margin: 0;\n  font-size: 38px;\n  line-height: 1.1;\n  color: #1f2937;\n  font-weight: 700;\n}\n\n.pq-add-agent-subtitle {\n  margin: 6px 0 0;\n  color: #6b7280;\n  font-size: 16px;\n}\n\n.pq-add-agent-close {\n  border: 0;\n  background: transparent;\n  color: #6b7280;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.pq-add-agent-section {\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  margin-bottom: 14px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.pq-add-agent-section-head {\n  height: 54px;\n  border-bottom: 1px solid #eef2f7;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 14px;\n  color: #374151;\n  font-size: 30px;\n  font-weight: 700;\n}\n\n.pq-add-agent-section-head i {\n  font-size: 20px;\n}\n\n.pq-add-agent-section-head i.orange { color: #ea580c; }\n.pq-add-agent-section-head i.green { color: #16a34a; }\n.pq-add-agent-section-head i.purple { color: #9333ea; }\n.pq-add-agent-section-head i.pink { color: #db2777; }\n\n.pq-add-agent-grid-1,\n.pq-add-agent-grid-2,\n.pq-add-agent-grid-3 {\n  display: grid;\n  gap: 14px 16px;\n  padding: 16px 14px 14px;\n}\n\n.pq-add-agent-grid-1 { grid-template-columns: 1fr; }\n.pq-add-agent-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.pq-add-agent-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n\n.pq-add-agent-form-wrap .pq-text-input,\n.pq-add-agent-form-wrap .pq-select-input {\n  max-width: 100%;\n}\n\n.pq-add-agent-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.pq-text-input,\n.pq-textarea-input,\n.pq-select-input {\n  width: 100%;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  color: #111827;\n  font-size: 14px;\n  outline: none;\n}\n\n.pq-text-input {\n  height: 46px;\n  padding: 0 16px;\n  max-width: 605px;\n}\n\n.pq-textarea-input {\n  min-height: 140px;\n  padding: 16px 18px;\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.pq-helper-text {\n  margin: 10px 0 0;\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.pq-upload-box {\n  min-height: 290px;\n  border: 2px dashed #d1d5db;\n  border-radius: 14px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 28px;\n  text-align: center;\n  cursor: default;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.pq-upload-box.pq-upload-box--drag {\n  border-color: #3b82f6;\n  background: #f8fafc;\n}\n\n.pq-upload-icon {\n  font-size: 56px;\n  color: #9ca3af;\n  line-height: 1;\n  margin-bottom: 10px;\n}\n\n.pq-upload-text {\n  font-size: 16px;\n  color: #334155;\n  margin-bottom: 6px;\n}\n\n.pq-upload-or {\n  font-size: 14px;\n  color: #94a3b8;\n  margin-bottom: 14px;\n}\n\n.pq-browse-btn {\n  height: 40px;\n  padding: 0 18px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #1e293b;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pq-upload-support {\n  margin-top: 14px;\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.pq-artwork-file-list {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n  max-width: 605px;\n}\n\n.pq-artwork-file-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.pq-artwork-file-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #111827;\n}\n\n.pq-artwork-file-meta {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.pq-artwork-file-remove {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-artwork-file-remove:hover {\n  background: #e2e8f0;\n  color: #111827;\n}\n\n.pq-designer-group {\n  max-width: 340px;\n}\n\n.pq-designer-async-wrap {\n  position: relative;\n  z-index: 50;\n}\n\n.pq-designer-async-wrap .pq-designer-rs__control {\n  min-height: 46px;\n  border-radius: 10px;\n  border-color: #cbd5e1;\n  box-shadow: none;\n  font-size: 14px;\n}\n\n.pq-designer-async-wrap .pq-designer-rs__menu {\n  z-index: 9999;\n}\n\n.pq-designer-async-wrap .pq-designer-rs__control--is-focused {\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 1px #94a3b8;\n}\n\n.pq-designer-async-wrap .pq-designer-rs__indicator-separator {\n  display: none;\n}\n\n.pq-designer-async-wrap .pq-designer-rs__dropdown-indicator {\n  display: flex;\n  opacity: 1;\n  visibility: visible;\n}\n\n.pq-designer-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 46px;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.pq-select-wrap {\n  position: relative;\n}\n\n.pq-select-input {\n  height: 46px;\n  padding: 0 42px 0 16px;\n  appearance: none;\n  cursor: pointer;\n}\n\n.pq-select-wrap i {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #475569;\n  font-size: 18px;\n  pointer-events: none;\n}\n\n.pq-message-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.pq-message-label-row .pq-form-label {\n  margin-bottom: 0;\n}\n\n.pq-emoji-btn {\n  border: 0;\n  background: transparent;\n  color: #334155;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.pq-message-box {\n  min-height: 118px;\n}\n\n.pq-check-row {\n  margin-top: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #334155;\n}\n\n.pq-check-row input {\n  width: 16px;\n  height: 16px;\n}\n\n.pq-bottom-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 18px;\n  border-top: 1px solid #e5e7eb;\n  margin-top: 10px;\n}\n\n.pq-agent-details-card {\n  border: 1px solid #dbe1ea;\n  border-radius: 12px;\n  background: #fff;\n  padding: 22px 22px 24px;\n}\n\n.pq-agent-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* margin-bottom: 22px; */\n}\n\n.pq-agent-card-head h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-agent-edit-btn {\n  border: 0;\n  background: transparent;\n  color: #2563eb;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.pq-agent-grid-details {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px 56px;\n}\n/* \n.pq-k {\n  margin-bottom: 6px;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  font-weight: 600;\n} */\n/* \n.pq-v {\n  font-size: 15px;\n  line-height: 1.4;\n  color: #111827;\n  font-weight: 600;\n} */\n\n.pq-workflow-head {\n  padding: 24px 26px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.pq-workflow-head h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: #111827;\n}\n\n.pq-workflow-body {\n  padding: 26px 24px;\n}\n\n.pq-workflow-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pq-workflow-row {\n  display: grid;\n  grid-template-columns: 38px minmax(0, 1fr);\n  gap: 14px;\n}\n\n.pq-workflow-row + .pq-workflow-row {\n  margin-top: 10px;\n}\n\n.pq-workflow-line-col {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.pq-workflow-line {\n  position: absolute;\n  top: 38px;\n  bottom: -14px;\n  width: 2px;\n  background: #d1d5db;\n}\n\n.pq-workflow-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  position: relative;\n  z-index: 1;\n}\n\n.pq-workflow-icon.blue {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.pq-workflow-icon.purple {\n  background: #f3e8ff;\n  color: #9333ea;\n}\n\n.pq-workflow-icon.green {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.pq-workflow-icon.orange {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n.pq-workflow-icon.mint {\n  background: #dcfce7;\n  color: #059669;\n}\n\n.pq-workflow-content {\n  padding-top: 4px;\n}\n\n.pq-workflow-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.pq-workflow-detail,\n.pq-workflow-assigned {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #6b7280;\n}\n\n.pq-edit-status-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  padding: 16px 18px;\n}\n\n.pq-edit-status-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.pq-edit-status-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #059669;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.pq-edit-status-badge {\n  height: 30px;\n  padding: 0 14px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #4b5563;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n}\n\n.pq-edit-status-icon.inprogress {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.pq-edit-status-badge.inprogress {\n  background: #cffafe;\n  color: #0e7490;\n}\n\n.pq-edit-status-icon.quoted {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n.pq-edit-status-badge.quoted {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.pq-edit-status-icon.approved {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.pq-edit-status-badge.approved {\n  background: #d1fae5;\n  color: #15803d;\n}\n\n.pq-edit-status-icon.completed {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.pq-edit-status-badge.completed {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.pq-edit-status-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.pq-edit-status-text {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n@media (max-width: 1200px) {\n  .pq-create-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .pq-create-header {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 20px 16px;\n  }\n\n  .pq-create-layout {\n    padding: 16px;\n  }\n\n  .pq-create-card-body {\n    padding: 18px;\n  }\n\n  .pq-agent-grid-details {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .pq-message-label-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .pq-bottom-actions {\n    flex-direction: column;\n  }\n\n  .pq-footer-cancel-btn,\n  .pq-footer-primary-btn,\n  .pq-top-cancel-btn,\n  .pq-text-input,\n  .pq-designer-group {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .pq-add-agent-title {\n    font-size: 28px;\n  }\n\n  .pq-add-agent-grid-2,\n  .pq-add-agent-grid-3 {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n\n\n\n\n\n\n/* datatable,view,addandedit files mixed css code  */\n\n\n .project-quote-page {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  color: #111827;\n}\n\n.pq-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 15px;\n}\n\n.pq-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.pq-page-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 600;\n  color: #111827;\n}\n\n\n.pq-btn {\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.pq-btn-primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.pq-btn-outline {\n  background: #fff;\n  border-color: #d1d5db;\n  color: #374151;\n}\n\n.pq-toolbar {\n  display: grid;\n  grid-template-columns: 1fr 230px;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.pq-input,\n.pq-select,\n.pq-textarea {\n  width: 100%;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 9px 12px;\n  font-size: 14px;\n  background: #fff;\n}\n\n.pq-textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.pq-input:focus,\n.pq-select:focus,\n.pq-textarea:focus {\n  outline: 2px solid rgba(37, 99, 235, 0.2);\n  border-color: #2563eb;\n}\n\n.pq-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.pq-stat {\n  padding: 14px;\n  border-left: 4px solid #d1d5db;\n}\n\n.pq-stat-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.pq-stat.in-progress {\n  border-left-color: #06b6d4;\n}\n\n.pq-stat.approved {\n  border-left-color: #22c55e;\n}\n\n.pq-stat.quoted {\n  border-left-color: #f97316;\n}\n\n.pq-stat.quote-approved {\n  border-left-color: #2563eb;\n}\n\n.pq-stat.completed {\n  border-left-color: #9ca3af;\n}\n\n.pq-stat-value {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.pq-stat-label {\n  margin-top: 6px;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.pq-stat-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.pq-stat.in-progress .pq-stat-icon {\n  background: #cffafe;\n  color: #0e7490;\n}\n\n.pq-stat.approved .pq-stat-icon {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.pq-stat.quoted .pq-stat-icon {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.pq-stat.quote-approved .pq-stat-icon {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.pq-stat.completed .pq-stat-icon {\n  background: #f3f4f6;\n  color: #4b5563;\n}\n\n.pq-table-wrap {\n  overflow-x: auto;\n}\n\n.pq-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.pq-table th,\n.pq-table td {\n  border-bottom: 1px solid #f1f5f9;\n  padding: 12px;\n  font-size: 14px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.pq-table th {\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.pq-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.pq-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.25;\n}\n\n.pq-badge.in-progress {\n  background: #cffafe;\n  color: #0e7490;\n}\n\n.pq-badge.design-approved {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.pq-badge.quoted {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.pq-badge.quote-approved {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.pq-badge.completed {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.pq-action-group {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.pq-icon-btn {\n  width: 30px;\n  height: 30px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n}\n\n.pq-layout-two-col {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(300px, 1fr);\n  gap: 16px;\n}\n\n.pq-card-head {\n  border-bottom: 1px solid #f1f5f9;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n/* \n.pq-card-head h3 {\n  margin: 0;\n  font-size: 20px;\n} */\n\n.pq-card-body {\n  padding: 16px;\n}\n\n.pq-field-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.pq-field-grid .full {\n  grid-column: span 2;\n}\n\n.pq-field-label {\n  margin-bottom: 6px;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.pq-agent-box {\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 14px;\n}\n\n.pq-agent-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.pq-agent-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-agent-item-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 21px;\n  flex-shrink: 0;\n}\n\n.pq-agent-item-icon.user {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.pq-agent-item-icon.email {\n  background: #e0f2fe;\n  color: #0284c7;\n}\n\n.pq-agent-item-icon.phone {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.pq-agent-item-icon.brokerage {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n/* .pq-k {\n  color: #9ca3af;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n} */\n\n/* .pq-v {\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n} */\n\n.pq-split-line {\n  border-top: 1px solid #e5e7eb;\n  margin: 0 0 14px;\n}\n\n/* .pq-address-heading {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n} */\n\n.pq-meta-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.pq-upload-zone {\n  border: 2px dashed #d1d5db;\n  border-radius: 10px;\n  text-align: center;\n  color: #6b7280;\n  background: #f8fafc;\n  padding: 32px 12px;\n}\n\n.pq-workflow-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.pq-workflow-timeline {\n  position: relative;\n}\n\n.pq-workflow-timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 15px;\n  top: 8px;\n  bottom: 12px;\n  width: 2px;\n  background: #d1d5db;\n}\n\n.pq-workflow-item {\n  display: flex;\n  gap: 10px;\n  padding: 8px 0 14px;\n  border-bottom: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.pq-workflow-item:last-child {\n  border-bottom: 0;\n}\n\n.pq-workflow-dot {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  margin-top: 2px;\n  border: 1px solid #e5e7eb;\n}\n\n.pq-workflow-dot.done {\n  background: #dcfce7;\n  color: #16a34a;\n  border-color: #bbf7d0;\n}\n\n.pq-workflow-dot.progress {\n  background: #f3e8ff;\n  color: #7c3aed;\n  border-color: #d8b4fe;\n}\n\n.pq-wf-title {\n  font-weight: 700;\n  color: #1f2937;\n  line-height: 1.2;\n}\n\n.pq-wf-sub {\n  color: #6b7280;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.pq-wf-sub.done {\n  color: #16a34a;\n}\n\n.pq-wf-sub.progress {\n  color: #7c3aed;\n}\n\n\n\n.pq-workflow-item.dim {\n  opacity: 0.55;\n}\n\n.pq-tabs {\n  display: flex;\n  gap: 24px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 16px;\n}\n\n.pq-tab {\n  /* padding: 10px 0;\n  border: 0; */\n  background: transparent;\n  /* border-bottom: 2px solid transparent; */\n  color: #64748b;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.pq-tab.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n}\n\n.pq-msg-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  min-height: 160px;\n  padding: 12px;\n}\n\n.pq-msg-input-wrap {\n  margin-top: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.pq-msg-input {\n  border: 0;\n  width: 100%;\n  padding: 14px;\n  min-height: 100px;\n  resize: vertical;\n}\n\n.pq-msg-actions {\n  border-top: 1px solid #f1f5f9;\n  padding: 10px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pq-muted {\n  color: #6b7280;\n}\n\n.pq-view-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.pq-view-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pq-view-title {\n  margin: 0;\n  font-size: 21px;\n  font-weight: 500;\n}\n\n.pq-back-link {\n  border: 0;\n  background: transparent;\n  color: #334155;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n}\n\n.pq-status-pill {\n  background: #cffafe;\n  color: #0e7490;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* .pq-additional-btn {\n  width: 100%;\n  margin-top: 14px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  border-radius: 8px;\n  height: 38px;\n  color: #334155;\n} */\n\n/* Duplicate .pq-tabs-with-right / .pq-mute / .pq-convo-* (canonical: projectandquote-view.css)\n.pq-tabs-with-right { align-items: center; background: linear-gradient(to right, #eff6ff, #f8faff); margin: -16px -16px 16px; padding: 0 16px; border-bottom: 1px solid #dbeafe; }\n.pq-mute-btn { margin-left: auto; border: 0; background: transparent; color: #64748b; }\n.pq-convo-list { max-height: 390px; overflow: auto; padding-right: 2px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px; }\n.pq-convo-item { margin-bottom: 14px; padding: 0; border: 0; border-radius: 0; background: transparent; }\n.pq-convo-top { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-bottom: 8px; }\n.pq-convo-user { display: flex; align-items: center; gap: 8px; }\n.pq-convo-avatar { width: 34px; height: 34px; border-radius: 50%; background: #e5e7eb; color: #6b7280; display: inline-flex; align-items: center; justify-content: center; font-size: 16px; }\n.pq-convo-avatar.designer { background: #dbeafe; color: #2563eb; }\n.pq-convo-avatar.agent { background: #e5e7eb; color: #6b7280; }\n.pq-convo-role { font-size: 12px; color: #4b5563; background: #f3f4f6; border-radius: 999px; padding: 1px 8px; }\n.pq-convo-time { color: #6b7280; font-size: 12px; }\n.pq-convo-text { margin: 0; color: #334155; }\n.pq-convo-bubble-wrap { margin-top: 0; border: 1px solid #e6ebf2; border-radius: 10px; background: #f9fafb; padding: 12px 14px; }\n*/\n\n.pq-attachments {\n  margin-top: 10px;\n  display: grid;\n  gap: 8px;\n}\n\n.pq-attachment {\n  border: 1px solid #e2e8f0;\n  border-radius: 7px;\n  padding: 8px 10px;\n  font-size: 13px;\n  color: #334155;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.pq-attachment-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.pq-attachment-name {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.pq-proof-badge {\n  background: #e0e7ff;\n  color: #4338ca;\n  border: 1px solid #c7d2fe;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pq-btn-sm {\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 13px;\n}\n\n.pq-convo-separator {\n  border-top: 1px solid #e5e7eb;\n  margin: 12px 0;\n}\n\n.pq-attached-list {\n  padding: 0 12px 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pq-attached-pill {\n  border: 1px solid #e2e8f0;\n  border-radius: 999px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 12px;\n  padding: 4px 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.pq-attach-label {\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.pq-sticky-side {\n  position: sticky;\n  top: 16px;\n  align-self: start;\n}\n\n.pq-side-section {\n  border-top: 1px solid #e5e7eb;\n  margin-top: 12px;\n  padding-top: 14px;\n}\n\n.pq-side-title {\n  margin: 0 0 10px;\n  font-size: 14px;\n}\n\n.pq-side-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px;\n  margin-bottom: 12px;\n  background: #fff;\n}\n\n.pq-side-box-title {\n  font-size: 13px;\n  color: #1e3a8a;\n  font-weight: bold;\n  margin-bottom: 8px;\n  background: linear-gradient(to right, #eff6ff, #f5f8ff);\n}\n\n.pq-radio-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 2px;\n  border-top: 1px solid #f1f5f9;\n  border-radius: 6px;\n  transition: background 0.12s;\n}\n\n.pq-radio-row:hover {\n  background: #f8faff;\n}\n\n.pq-radio-row.selected {\n  background: #eff6ff;\n}\n\n.pq-radio-row:first-of-type {\n  border-top: 0;\n}\n\n.pq-radio-row small {\n  margin-left: auto;\n  color: #64748b;\n}\n\n.pq-proof-file-chip {\n  margin-left: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #4b5563;\n  font-size: 12px;\n  padding: 1px 8px;\n}\n\n.pq-full-btn {\n  width:92%;\n  margin-top: 8px;\n  justify-content: center;\n}\n\n.pq-btn-disabled {\n  color: #9ca3af;\n  border-color: #e5e7eb;\n  background: #f8fafc;\n}\n\n.pq-required {\n  color: #ef4444;\n}\n\n.pq-order-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-order-row i {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-size: 16px;\n}\n\n.pq-cancel-btn {\n  color: #b91c1c;\n  border-color: #fecaca;\n  background: #fff1f2;\n}\n\n.pq-ref-head {\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 12px;\n  margin-bottom: 18px;\n}\n\n.pq-ref-back {\n  margin-top: 3px;\n}\n\n.pq-ref-divider {\n  width: 1px;\n  height: 20px;\n  background: #d1d5db;\n}\n\n.pq-ref-title {\n  font-size: 28px;\n}\n\n.pq-actions-wrap {\n  position: relative;\n}\n\n.pq-ref-actions {\n  min-width: 110px;\n  justify-content: space-between;\n}\n\n.pq-actions-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  width: 160px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.1);\n  z-index: 20;\n  overflow: hidden;\n}\n\n.pq-actions-menu button {\n  width: 100%;\n  border: 0;\n  background: #fff;\n  text-align: left;\n  padding: 9px 12px;\n  color: #334155;\n}\n\n.pq-actions-menu button:hover {\n  background: #f8fafc;\n}\n\n.pq-actions-menu i {\n  margin-right: 6px;\n}\n\n/* .pq-ref-card-head-blue {\n  background: linear-gradient(to right, #eff6ff, #fff);\n  border-bottom-color: #e6edf8;\n} */\n\n.pq-ref-card-head-indigo {\n  background: linear-gradient(to right, #eef2ff, #fff);\n  border-bottom-color: #e9e8fb;\n}\n\n/* .pq-ref-head-title {\n  font-size: 17px !important;\n  color: #1e3a8a;\n} */\n\n/* .pq-expand-details {\n  border-top: 1px solid #e5e7eb;\n  margin-top: 14px;\n  padding-top: 14px;\n} */\n\n.pq-shared-files {\n  display: grid;\n  gap: 12px;\n}\n\n.pq-proof-group {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.pq-proof-group-head {\n  background: #eef2ff;\n  color: #4f46e5;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 8px 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pq-proof-group-head.plain {\n  background: #f8fafc;\n  color: #475569;\n}\n\n.pq-proof-chip {\n  border: 1px solid #a5b4fc;\n  background: #fff;\n  border-radius: 999px;\n  padding: 2px 7px;\n}\n\n.pq-file-row {\n  display: grid;\n  grid-template-columns: 40px 1fr auto;\n  gap: 25px;\n  padding: 12px;\n  border-top: 1px solid #f1f5f9;\n  align-items: center;\n}\n\n.pq-file-type {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  color: #7f1d1d;\n  background: #fee2e2;\n}\n\n.pq-file-type.jpg {\n  color: #1e40af;\n  background: #dbeafe;\n}\n\n.pq-file-meta {\n  min-width: 0;\n}\n\n.pq-file-name {\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-file-sub {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.pq-file-actions {\n  display: flex;\n  gap: 8px;\n  color: #94a3b8;\n}\n\n.pq-side-section-green {\n  border-top-color: #dcfce7;\n}\n\n.pq-side-section-green .pq-side-title {\n  color: #166534;\n  font-weight: 700;\n}\n\n@media (max-width: 1100px) {\n  .pq-layout-two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-stats-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .pq-toolbar {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-field-grid,\n  .pq-agent-grid,\n  .pq-meta-row {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-field-grid .full {\n    grid-column: span 1;\n  }\n\n  .pq-stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-view-title {\n    font-size: 21px;\n  }\n}\n\n/* Google Places: custom two-line suggestion list (AutocompleteService) */\n.pq-gac-wrap {\n  position: relative;\n  z-index: 5;\n}\n\n.pq-gac-dropdown {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 4px);\n  margin: 0;\n  padding: 4px 0;\n  list-style: none;\n  max-height: 280px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.12);\n}\n\n.pq-gac-item {\n  padding: 10px 14px 10px 12px;\n  cursor: pointer;\n  border-left: 4px solid transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pq-gac-item:hover,\n.pq-gac-item--active {\n  background: #eff6ff;\n  border-left-color: #2563eb;\n}\n\n.pq-gac-main {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.pq-gac-secondary {\n  font-size: 13px;\n  font-weight: 400;\n  color: #64748b;\n  line-height: 1.35;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
